import React from 'react';
import rondoshareLogo from '../assets/rondoshare-logo.png';

interface SiteLogoProps {
  className: string;
}

export const SiteLogo: React.FC<SiteLogoProps> = ({ className }) => (
  <span className="site-logo-wrap">
    <img src={rondoshareLogo} alt="rondoshare" className={className} />
    <img
      src={`${process.env.PUBLIC_URL}/beta.png`}
      alt=""
      className="site-logo-beta"
      aria-hidden="true"
    />
  </span>
);
